var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hero" }, [
    _c("div", { staticClass: "hero-body" }, [
      _c("div", { staticClass: "container" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle is-4" }, [
          _vm._v(
            "\n      南極観測隊員になって基地や「しらせ」を見てみよう\n      "
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "main-contents" },
          [
            _c("div", { staticClass: "content-title subtitle is-2" }, [
              _vm._v("\n          南極観測船「しらせ」ウォークビュー\n        ")
            ]),
            _vm._v(" "),
            _c(
              "router-link",
              {
                attrs: {
                  to: { name: "view", params: { id: _vm.startNumber.shirase } }
                }
              },
              [
                _c("img", {
                  staticClass: "shirase",
                  attrs: { src: "asset/shirase.jpeg", alt: "しらせ" }
                })
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "subtitle is-4" }, [
              _vm._v(
                "\n          「しらせ」は年に一回、日本と南極を往復します。観測を行いながら観測隊員と荷物を南極まで運ぶのが仕事です。「しらせ」の中で観測隊の暮らすスペースを実際に回ってみましょう。\n        "
              )
            ]),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "button is-link is-large is-3",
                attrs: {
                  to: { name: "view", params: { id: _vm.startNumber.shirase } }
                }
              },
              [
                _vm._v(
                  "\n          南極観測船「しらせ」ウォークビュー\n        "
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "main-contents" },
          [
            _c("div", { staticClass: "content-title subtitle is-2" }, [
              _vm._v("\n          昭和基地ウォークビュー\n        ")
            ]),
            _vm._v(" "),
            _c(
              "router-link",
              {
                attrs: {
                  to: { name: "view", params: { id: _vm.startNumber.east } }
                }
              },
              [
                _c("img", {
                  staticClass: "syowa",
                  attrs: { src: "asset/syowa.jpeg", alt: "昭和基地" }
                })
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "subtitle is-4" }, [
              _vm._v(
                "\n          昭和基地は隊員が南極で観測活動を行うための日本の主要基地です。毎年隊員が入れ替わり、半世紀を超えて維持、管理、運用を続けています。観測隊員になった気持ちで昭和基地の主要部を回ってみましょう。\n        "
              )
            ]),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "button is-link is-large is-3",
                attrs: {
                  to: { name: "view", params: { id: _vm.startNumber.east } }
                }
              },
              [_vm._v("\n          昭和基地ウォークビュー\n        ")]
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column is-9" }, [
        _c("div", { staticClass: "title is-1" }, [
          _vm._v("\n            南極観測隊ウォークビュー\n          ")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "column is-3" }, [
        _c("div", { staticClass: "subtitle is-4" }, [
          _c(
            "a",
            {
              staticClass: "button is-large is-3",
              attrs: { href: "pdf/VRAntarctic_manual.pdf", target: "_blank" }
            },
            [_vm._v("\n              使い方\n            ")]
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }